module.exports = __webpack_public_path__ + "img/zuckerberg-turquoise.1ea1b5fb.png";